import { render, staticRenderFns } from "./MainJouNalSummCard.vue?vue&type=template&id=51bf5294&scoped=true&"
import script from "./MainJouNalSummCard.vue?vue&type=script&lang=js&"
export * from "./MainJouNalSummCard.vue?vue&type=script&lang=js&"
import style0 from "./MainJouNalSummCard.vue?vue&type=style&index=0&id=51bf5294&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bf5294",
  null
  
)

export default component.exports